/* @flow */
export const PICK_BRIDGE_RECOMMENDATION = 'PICK_BRIDGE_RECOMMENDATION';
import type { Action } from './types';
import { sample } from '../utils/dom';
import {filter} from 'lodash';

// Not a pure function. Please use on client-side only.
export const pickBridgeRecommendation = (recommendations: Array<UpNextState>, entryId: number): Action => {
  const filtered = filter(
    recommendations,
    (recommendation: UpNextState): bool => recommendation.id !== entryId
  );
  return {
    type: PICK_BRIDGE_RECOMMENDATION,
    data: sample(filtered)
  };
};

export type UpNextState = {
  id?: number,
  url?: string,
  opener_image?: string,
  type?: string
}
